<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.categoryId" clearable filterable placeholder="一级分类">
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="formatTaxonomyLabel(item)"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.nameZh" clearable placeholder="二级分类中文名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.nameEn" clearable placeholder="二级分类英文名" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.isActive" clearable placeholder="启用状态">
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleAdd">新增二级分类</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        :data="results"
        height="100%"
        border
        stripe
        highlight-current-row
      >
        <el-table-column prop="id" label="ID" min-width="220" />
        <el-table-column label="一级分类" min-width="180">
          <template slot-scope="scope">
            {{ categoryMap[scope.row.categoryId] || scope.row.categoryId }}
          </template>
        </el-table-column>
        <el-table-column prop="nameZh" label="中文名" min-width="160" />
        <el-table-column prop="nameEn" label="英文名" min-width="180" />
        <el-table-column prop="sortOrder" label="排序" width="90" align="center" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'info'">
              {{ scope.row.isActive ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteSubmit(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog
      :visible.sync="formVisible"
      :close-on-click-modal="false"
      :title="formMode === 'create' ? '新增二级分类' : '编辑二级分类'"
      width="560px"
    >
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="100px">
        <el-form-item label="一级分类" prop="categoryId">
          <el-select v-model="editForm.categoryId" filterable placeholder="请选择一级分类" style="width: 100%">
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="formatTaxonomyLabel(item)"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="中文名" prop="nameZh">
          <el-input v-model.trim="editForm.nameZh" placeholder="请输入二级分类中文名" />
        </el-form-item>
        <el-form-item label="英文名" prop="nameEn">
          <el-input v-model.trim="editForm.nameEn" placeholder="请输入二级分类英文名" />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="editForm.sortOrder" :min="0" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editForm.isActive" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitForm">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

const createEmptyMarketSubcategoryForm = () => ({
  id: "",
  categoryId: "",
  nameZh: "",
  nameEn: "",
  sortOrder: 0,
  isActive: true,
});

export default {
  name: "MarketSubcategories",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {
        page: 1,
        limit: 20,
        total: 0,
      },
      filters: {
        categoryId: "",
        nameZh: "",
        nameEn: "",
        isActive: "",
      },
      categories: [],
      categoryMap: {},
      formVisible: false,
      formMode: "create",
      submitLoading: false,
      editForm: createEmptyMarketSubcategoryForm(),
      editFormRules: {
        categoryId: [{ required: true, message: "请选择一级分类", trigger: "change" }],
        nameZh: [{ required: true, message: "请输入二级分类中文名", trigger: "blur" }],
        nameEn: [{ required: true, message: "请输入二级分类英文名", trigger: "blur" }],
      },
    };
  },
  mounted() {
    mainHeight(this);
    this.loadCategories();
    this.list();
  },
  methods: {
    emptyForm() {
      return createEmptyMarketSubcategoryForm();
    },
    formatTaxonomyLabel(item) {
      if (!item) {
        return "";
      }
      const labels = [item.nameZh, item.nameEn].filter((value) => !!value);
      if (labels.length > 0) {
        return labels.join(" / ");
      }
      return item.key || item.id;
    },
    search() {
      this.page.page = 1;
      this.list();
    },
    loadCategories() {
      this.axios
        .form("/api/admin/market-category/list", {
          page: 1,
          limit: 100000,
        })
        .then((data) => {
          this.categories = data.results || [];
          this.categoryMap = {};
          for (let i = 0; i < this.categories.length; i++) {
            this.categoryMap[this.categories[i].id] = this.formatTaxonomyLabel(this.categories[i]);
          }
        });
    },
    list() {
      this.listLoading = true;
      const params = {
        categoryId: this.filters.categoryId,
        name_zh: this.filters.nameZh,
        name_en: this.filters.nameEn,
        isActive: this.filters.isActive,
        page: this.page.page,
        limit: this.page.limit,
      };
      this.axios
        .form("/api/admin/market-subcategory/list", params)
        .then((data) => {
          this.results = data.results || [];
          this.page = data.page || { page: 1, limit: 20, total: 0 };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.formMode = "create";
      this.editForm = this.emptyForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    handleEdit(row) {
      this.axios
        .get("/api/admin/market-subcategory/" + row.id)
        .then((data) => {
          this.formMode = "edit";
          this.editForm = Object.assign({}, this.emptyForm(), data);
          this.formVisible = true;
          this.$nextTick(() => {
            this.$refs.editForm && this.$refs.editForm.clearValidate();
          });
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        const apiUrl =
          this.formMode === "create"
            ? "/api/admin/market-subcategory/create"
            : "/api/admin/market-subcategory/update";
        this.submitLoading = true;
        this.axios
          .form(apiUrl, this.editForm)
          .then(() => {
            this.$message({ type: "success", message: this.formMode === "create" ? "创建成功" : "更新成功" });
            this.formVisible = false;
            this.list();
          })
          .catch((err) => {
            this.$notify.error({ title: "错误", message: err.message || err });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    deleteSubmit(row) {
      this.$confirm("是否删除该二级分类？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios.form("/api/admin/market-subcategory/delete", { id: row.id }).then(() => {
            this.$message({ type: "success", message: "删除成功" });
            this.list();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
